// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-page[data-v-0f51eec8],.content-tab[data-v-0f51eec8]{height:calc(100vh - 220px)!important}", ""]);
// Exports
module.exports = exports;
